<template>
    <div class="nav">
        <van-nav-bar :title="navtitle" left-text="返回" left-arrow @click-left="back">
            <template #right>
                <router-link class="tablogo" to="/"><img src="../assets/tablogo.png" alt=""></router-link>
            </template>
        </van-nav-bar>
    </div>
</template>

<script>
export default {
    props: ['navtitle'],
    date () {
        return {
        }
    },
    methods: {
        back () {
            if (window.history.length <= 1) {
                return;
            }
            if (this.$router.history.current.meta.BackUrl && this.$router.history.current.meta.BackUrl !== '') {
                this.$router.push({ name: this.$router.history.current.meta.BackUrl }, () => { }, () => { });
            } else {
                this.$router.go(-1);//返回上一层
            }
        }
    }
}
</script>


<style>
.nav .van-nav-bar__left {
    padding-left: 15px;
}
.nav .van-nav-bar__right {
    padding: 0;
}
.nav .van-nav-bar__title {
    font-weight: bold;
}
.tablogo img {
    width: 40%;
    margin-top: 10px;
}
</style>